import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MediaFormat, MediaItem, MediaUploadItem, SelectedFile, UploadStatus } from '@app/models/media-files';

@Component({
  selector: 'flow-media-upload-item',
  templateUrl: './media-upload-item.component.html',
  styleUrls: ['./media-upload-item.component.scss'],
})
export class MediaUploadItemComponent {
  @Input() media: any; 
  @Input() selectedMedia!: any;
  @Input() uploadingDone!: boolean;
  @Input() mediaIndex: number;
  @Input() disableActions = false;
  @Input() hideLoader = false;
  @Output() edit = new EventEmitter();
  @Output() remove = new EventEmitter();
  @Output() reload = new EventEmitter();
  UploadStatus = UploadStatus;
  MediaFormat = MediaFormat;

  get hasEditOutputSubscriber(): boolean {
    return this.edit.observed; 
  }

  get hasReloadOutputSubscriber(): boolean {
    return this.reload.observed;
  }
  
  editMedia(mediaGroup: MediaItem | MediaUploadItem | SelectedFile) {
    this.edit.emit(mediaGroup);
  }

  removeMedia(mediaGroup: MediaItem | MediaUploadItem | SelectedFile, index: number) {
    this.remove.emit({ mediaGroup, index });
  }

  reloadMedia(mediaGroup: MediaItem | MediaUploadItem | SelectedFile, index: number) {
    this.reload.emit({ mediaGroup, index, isRefresh: true });
  }
}
